/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeStringCombinableCriteria } from './EListSearchTypeStringCombinableCriteria';
import {
    EListSearchTypeStringCombinableCriteriaFromJSON,
    EListSearchTypeStringCombinableCriteriaFromJSONTyped,
    EListSearchTypeStringCombinableCriteriaToJSON,
} from './EListSearchTypeStringCombinableCriteria';

/**
 * 
 * @export
 * @interface StringListSearch
 */
export interface StringListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeStringCombinableCriteria>}
     * @memberof StringListSearch
     */
    criterias?: Array<EListSearchTypeStringCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof StringListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {string}
     * @memberof StringListSearch
     * @deprecated
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringListSearch
     * @deprecated
     */
    secondaryValue?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof StringListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the StringListSearch interface.
 */
export function instanceOfStringListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StringListSearchFromJSON(json: any): StringListSearch {
    return StringListSearchFromJSONTyped(json, false);
}

export function StringListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeStringCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function StringListSearchToJSON(value?: StringListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeStringCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
        'defaultSearchType': value.defaultSearchType,
    };
}

